// Style Theme

export default {
  color: {
    red: "#C80A14",
    grey: "#DDDDDD",
    white: "#FFFFFF",
    black: "#000000"
  },
  font: {
    bold: "DFL-Bd"
  }
};



// WEBPACK FOOTER //
// ./src/theme.ts